import { render, staticRenderFns } from "./CurrencyDropdown.vue?vue&type=template&id=51942cbd&scoped=true&"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=js&"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDropdown.vue?vue&type=style&index=0&id=51942cbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51942cbd",
  null
  
)

export default component.exports